import type { PropsWithChildren, ReactNode } from "react"
import styles from "./Card.module.css"

interface CardProps extends PropsWithChildren {
  title: string
  headerAction?: ReactNode
  className?: string
}

function Card({ title, headerAction, children, className }: CardProps) {
  return (
    <div className={`${styles.card} ${className ?? ""}`} data-testid="card">
      <div className={styles.header}>
        <span className={`${styles.title} fr-text-300-strong`}>{title}</span>
        {headerAction && headerAction}
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  )
}

export default Card
